import { faEye, faCopy } from '@fortawesome/free-regular-svg-icons';
import { faDownload, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Badge, Button, Col, Container, FloatingLabel, Form, Modal, Row, Table } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import ActivityLog from '../../ActivityLog';
import CancelDialog from '../../CancelDialog';
import * as Common from "../../Common";
import Dialog from '../../Dialog';
import DialogYesNo from '../../Dialog_Yes_No';
import LoginHeader from '../../Login_header';
import Master_individual_profile from '../../master/Master_individual_profile';
import Menu from '../../Menu';
import * as Picklist from '../../Picklist';
import Tran_data_unlock_request from '../../Tran_data_unlock_request';

const Tran_fa_book = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const [userRight, setUserRight] = useState([]);
    const [uploadRight, setUploadRight] = useState([]);
    const [uploadCSRight, setUploadCSRight] = useState([]);
    const finStartDate = sessionStorage.getItem("startDate");
    const finEndDate = sessionStorage.getItem("endDate");
    const branchDisable = sessionStorage.getItem('branchDisable');

    const [selectedLocation, setSelectedLocation] = useState(null);
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [selectedOption, setSelectedOption] = useState({ value: 'BK', label: 'Bank Book' });
    const [selectLocationtype, setSelectLocationtype] = useState({ value: 'O', label: 'Single' });
    const [flag, setFlag] = useState('C');
    const [amount, setAmount] = useState("");
    const [onceRun, setOnceRun] = useState(false);
    const [radioType, setRadioType] = useState("N");
    const [srnoFrom, setSrnoFrom] = useState("");
    const [srnoTo, setSrnoTo] = useState("");
    const [ledgerValue, setLedgerValue] = useState(null);
    const [srNo, setSrNo] = useState("0");
    const [location, setLocation] = useState("");
    const [locationCode, setLocationCode] = useState("");
    const [showList, setShowList] = useState(false);
    const [filterDate, setFilterDate] = useState(new Date());
    const [bookList, setBookList] = useState([]);
    const [showHeaderList, setShowHeaderList] = useState(false);
    const [headerList, setHeaderList] = useState([]);
    const [counter, setCounter] = useState("0");
    const [viewSrno, setViewSrno] = useState("");
    const [viewDate, setViewDate] = useState("");
    const [viewType, setViewType] = useState("");
    const [viewAccount, setViewAccount] = useState(null);

    const [knockoffData, setKnockoffData] = useState([]);

    const [knockoffValue, setKnockoffValue] = useState(null);
    const [knockoffSrno, setKnockoffSrno] = useState('');
    const [knockoffType, setKnockoffType] = useState('');
    const [knockoffAmt, setKnockoffAmt] = useState('');
    const [knockoffPending, setKnockoffPending] = useState('');
    const [knockoffLineNo, setKnockoffLineNo] = useState('');
    const [knockoffFlag, setKnockoffFlag] = useState('');
    const [knockoffLedger, setKnockoffLedger] = useState('');

    const [showKnockoff, setShowKnockoff] = useState(true);
    const [show, setShow] = useState(false);

    const [limit, setLimit] = useState('100');
    const [srch, setSrch] = useState('');

    const [totalDebit, setTotalDebit] = useState("0");
    const [totalCredit, setTotalCredit] = useState("0");
    const [totalDifference, setTotalDifference] = useState("0");
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");
    const [narration, setNarration] = useState("");
    const [scrMode, setScrMode] = useState("");
    const [addCount, setAddCount] = useState("0");
    const [showIndividualList, setIndividualList] = useState(false);
    const [nIndividual, setNIndividual] = useState(null);
    const [nCorporate, setNCorporate] = useState(null);
    const [nState, setNState] = useState({ value: 0, label: "Select" });
    const [faStateValue, setFAStateValue] = useState(0);
    const [faStateName, setFAStateName] = useState("");
    const [showIndividualForm, setShowIndividualForm] = useState(false);
    const [showCheque, setShowCheque] = useState(false);
    const [chequeNum, setChequeNum] = useState("");
    const [bankName, setBankName] = useState("");
    const [chequeDate, setChequeDate] = useState(new Date());
    const [mvgType, setMvgType] = useState("");
    const [chequeStatus, setChequeStatus] = useState(null);
    const [type, setType] = useState('T');
    const [chequeValue, setChequeValue] = useState("");
    const [chequeValueNum, setChequeValueNum] = useState("");
    const [chequeLine, setChequeLine] = useState("");
    const [chequeSrno, setChequeSrno] = useState("");
    const [chequeLocation, setChequeLocation] = useState("");
    const [grpCode, setGrpCode] = useState("0");
    const [accCode, setAccCode] = useState("0");
    const options = [
        { value: 'BK', label: 'Bank Book' },
        { value: 'CS', label: 'Cash Book' },
        { value: 'JV', label: 'Journal Voucher' },
    ];
    const locationOptionsType = [
        { value: 'O', label: 'Single' },
        { value: 'M', label: 'Multi' },
    ];
    const [displayFlag, setDiplayFlag] = useState('');
    const [isChecked, setChecked] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [acRemark, setAcRemark] = useState("");
    const [code, setCode] = useState(0);
    const [showEditRequest, setShowEditRequest] = useState(false);
    const [editLogObject, setEditLogObject] = useState({ trantype: "", trannumber: "", trancategory: "", tranDate: "" });
    const [editReqDate, setEditReqDate] = useState('');
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });
    const [showActivityLog, setShowActivityLog] = useState(false);
    const [randomString, setRandomString] = useState("0");

    const currentDate = new Date();
    const [unlockRequestType, setUnlockRequestType] = useState("");
    const [isKnockOff, setIsKnockOff] = useState("0");
    const [showUploadOption, setShowUploadOption] = useState(false);
    const [file, setFile] = useState(null);
    const [tranAuditTrail, setTranAuditTrail] = useState([]);

    const [userCancelBillRight, setUserCancelBillRight] = useState([]);
    const [msgBoxYNBillDelete, setMsgBoxYNBillDelete] = useState(false);
    const [msgTextYNBillDelete, setMsgTextYNBillDelete] = useState("");
    const [picklistIndividualCode, setPicklistIndividualCode] = useState("");
    const [picklistIndividualName, setPicklistIndividualName] = useState("");
    const [tempLineNo, setTempLineNo] = useState(1);
    const [hideNextBtn, setHideNextBtn] = useState(false);
    const [hidePrevBtn, setHidePreBtn] = useState(false);
    const [selectiveTotalAmount, setSelectiveTotalAmount] = useState(0);
    const [uploadMultilocationRight, setUploadMultilocationRight] = useState([]);
    const [isBranchDisableForAddNew, setIsBranchDisableForAddNew] = useState("");




    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.getActiveBranch().then(response => {
                setSelectedLocation(response);
                response != null && handleChange(response);
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_BOOK_ENTRY'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_DELETE_BILL'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserCancelBillRight(resp);
                }
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_BOOK_UPLOAD'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUploadRight(resp);
                }
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_BOOK_ENTRY_UPLOAD_CS'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUploadCSRight(resp);
                }
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_BOOK_UPLOAD_MULTILOCATION'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUploadMultilocationRight(resp);
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handleCheckboxChange = () => {
        setChecked(!isChecked);
    };

    const handleAddNew = () => {
        var msg = [], i = 0;
        var d = Common.dateYMD(filterDate);
        var today = Common.dateYMD(new Date());
        if (selectedLocation === null || !filterDate) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (selectedLocation === null ? "Select Location." : '');
            msg[i++] = (!filterDate ? "Select Date." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (d > finEndDate || d < finStartDate) {
            setMsgText(Common.getMessage("MSG0010"));
            setMsgBox(true);
        } else if (d > today) {
            setMsgBox(true);
            setMsgText(Common.getMessage("MSG0011"));
        }
        // else if (+isBranchDisableForAddNew === 1) {
        //     setMsgBox(true);
        //     setMsgText("Branch Disable .New Entry not Allowed.");
        // }
        else {
            if (d == today) {
                addNewFormResetFields();
            } else {
                const obj = {
                    billdate: d,
                    location: locationCode,
                    type: selectedOption.value
                }
                Common.callApi(Common.apiDataUnlock, [sid, 'addnewunlock', JSON.stringify(obj)], result => {
                    let resp = JSON.parse(result);
                    if (resp.msg === "1") {
                        addNewFormResetFields();
                    } else {
                        setMsgBox(true);
                        setMsgText(Common.getMessage("MSG0012"));
                    }
                });
            }
        }
        setAddCount(0);
        setCode(0);
    }

    const addNewFormResetFields = () => {
        setScrMode('A');
        setSrNo(0);
        setViewSrno(0);
        setLedgerValue(null);
        setShowHeaderList(false);
        setShowList(true);
        setBookList([]);
        setTotalCredit('0');
        setTotalDebit('0');
        setTotalDifference('0');
        setNarration("");
        setViewType(selectedOption.value);
        setViewDate(Common.dateDMY(filterDate));
        setRandomString(Common.getRandomString(15));
        setIsKnockOff("0");
        setTempLineNo(1);
    }

    const handleAdd = () => {
        $(".loader").show();
        console.log(bookList);
        var msg = [], i = 0, chequeNumLocal = '';
        setChequeNum(chequeNum.trim());
        chequeNumLocal = chequeNum.trim();

        let account;
        let accountType;
        if (ledgerValue != null) {
            account = ledgerValue.id.split('^');
            accountType = account[4];
        }
        if (amount == "" || ledgerValue == null || (accountType == 'CHEQUE' && chequeDate == null) ||
            (accountType == 'CHEQUE' && chequeNumLocal == '') ||
            (accountType == 'CHEQUE' && bankName == '') || (accountType == 'BANK' && flag == 'C' && type == 'T' && chequeNumLocal == '') ||
            (accountType == 'BANK' && flag == 'C' && type == 'C' && chequeNumLocal == '') ||
            (flag == 'D' && type == 'T' && accountType == 'BANK' && chequeNumLocal == '') ||
            (flag == 'D' && type == 'C' && accountType == 'BANK' && chequeNumLocal == '')
            || (flag == 'D' && type == 'C' && accountType == 'BANK' && bankName == '')
            || (accountType === "WALKIN" && nIndividual === null && knockoffValue === null)
            || ((accountType == 'BANK') && (bookList.some(item => item.tfd_group === account[1] && item.tfd_account === account[2] && item.tfd_cheque_no === chequeNumLocal)))
        ) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (ledgerValue == null ? "Please select account." : '');
            msg[i++] = (amount === '' ? "Please fill amount." : '');
            msg[i++] = ((accountType == 'CHEQUE' && chequeNumLocal == '') ? 'Fill Cheque number' : '');
            msg[i++] = ((accountType == 'CHEQUE' && bankName == '') ? 'Fill Bank Name' : '');
            msg[i++] = ((accountType == 'CHEQUE' && chequeDate == null) ? "Please select date." : '');
            msg[i++] = ((accountType == 'BANK' && flag == 'C' && type == 'T' && chequeNumLocal == '') ? 'Fill Reference Number' : '');
            msg[i++] = ((accountType == 'BANK' && flag == 'C' && type == 'C' && chequeNumLocal == '') ? 'Fill Cheque Number' : '');
            msg[i++] = ((accountType == 'BANK' && flag == 'D' && type == 'T' && chequeNumLocal == '') ? 'Fill Reference Number' : '');
            msg[i++] = ((accountType == 'BANK' && flag == 'D' && type == 'C' && chequeNumLocal == '') ? 'Fill Cheque Number' : '');
            msg[i++] = ((flag == 'D' && type == 'C' && accountType == 'BANK' && bankName == '') ? 'Fill Bank Name' : '');
            msg[i++] = ((accountType === "WALKIN" && nIndividual === null && knockoffValue === null) ? "Individual is mandatory when walkin is picked." : "");
            msg[i++] = (((accountType == 'BANK') && (bookList.some(item => item.tfd_group === account[1] && item.tfd_account === account[2] && item.tfd_cheque_no === chequeNumLocal))) ? "Reference number already exist." : "");
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        }
        else {
            setAddCount(addCount + 1);
            $(".loader").hide();
            // const account = ledgerValue.id.split('^');

            const groupCode = account[1];
            const accountCode = account[2];
            let individual_name = '';
            let individual_id = 0;
            if (knockoffValue !== null) {
                individual_name = picklistIndividualName;
                individual_id = picklistIndividualCode;
            } else {
                if (nIndividual != null) {
                    let individual = nIndividual.id.split('^');
                    individual_name = individual[2];
                    individual_id = individual[1];
                }
            }

            let chqDate = "";
            let transferType = "";
            if (accountType == 'CHEQUE') {
                chqDate = Common.dateYMD(chequeDate);
            } else if (accountType == 'BANK') {
                transferType = type;
                chqDate = chequeDate;
            }
            let amt = amount;
            if (flag == 'C') {
                if (amount > 0) {
                    amt = -1 * amount;
                }
            } else {
                if (amount < 0) {
                    amt = -1 * amount;
                }
            }
            let tcbb_srno = 0;
            let tcbb_line_no = 0;
            let tcbb_location = 0;
            let tcbb_from = 0;
            let tcbb_type = "";
            if (mvgType === "BANK" && type === "C") {
                const ch = chequeValue.id.split("^");
                tcbb_srno = ch[1];
                tcbb_line_no = ch[2];
                tcbb_location = ch[3];
                tcbb_from = ch[4];
                tcbb_type = ch[5];
            }
            let obj;
            if (knockoffValue == null) {
                console.log('chqDate', chqDate);
                obj = {
                    TabType: "Product",
                    ALineNo: tranAuditTrail.length + 1,
                    AType: "A",
                    TLoc: locationCode,
                    TType: selectedOption.value,
                    uniquekey: Common.getRandomString(15),
                    tfd_date: Common.dateYMD(filterDate),
                    type: selectedOption,
                    tfd_type: selectedOption.value,
                    tfd_flag: flag,
                    tfd_amount: amt,
                    tfd_location: locationCode,
                    tfd_group: account[1],
                    tfd_account: account[2],
                    tfd_account_type: account[4],
                    mvli_ledger_name: account[3],
                    srno: srNo,
                    tfd_individual: individual_name,
                    tfd_individual_code: individual_id,
                    tfd_cheque_no: chequeNumLocal,
                    tfd_cheque_bank_name: accountType == 'BANK' ? account[3] : bankName,
                    cheque_date: (chqDate === null ? null : Common.dateYMD(chqDate)),
                    tfd_cheque_status: chequeStatus,
                    chequeValueNum: chequeValueNum,
                    tfd_transfer_type: transferType,
                    tfd_knockoff_srno: 'null',
                    tfd_knockoff_type: "",
                    tfd_knockoff_lineno: 'null',
                    delny: 'Y',
                    tfd_reftype: "",
                    tfd_srno: srNo,
                    tfd_line_no: 0,

                    tcbb_srno: tcbb_srno,
                    tcbb_line_no: tcbb_line_no,
                    tcbb_location: tcbb_location,
                    tcbb_from: tcbb_from,
                    tcbb_type: tcbb_type
                }
            } else {
                obj = {
                    TabType: "Product",
                    ALineNo: tranAuditTrail.length + 1,
                    AType: "A",
                    TLoc: locationCode,
                    TType: selectedOption.value,
                    tfd_location: locationCode,
                    tfd_type: knockoffType,
                    tfd_srno: knockoffSrno,
                    tfd_line_no: knockoffLineNo,
                    tfd_knockoff_type: knockoffType,
                    tfd_knockoff_srno: knockoffSrno,
                    tfd_knockoff_lineno: knockoffLineNo,
                    tfd_group: grpCode,
                    tfd_account: accCode,
                    tfd_amount: amt,
                    tfd_flag: knockoffFlag == 'D' ? 'C' : 'D',
                    tfd_date: Common.dateYMD(filterDate),
                    mvli_ledger_name: knockoffLedger,
                    randomString: randomString,
                    delny: 'Y',
                    tfd_transfer_type: "",
                    tfd_cheque_status: "",
                    cheque_date: "",
                    tfd_cheque_bank_name: "",
                    tfd_cheque_no: "",
                    tfd_individual_code: "",
                    tfd_account_type: "",
                    chequeValueNum: "",
                    tfd_reftype: "",
                    uniquekey: Common.getRandomString(15),

                    tcbb_srno: tcbb_srno,
                    tcbb_line_no: tcbb_line_no,
                    tcbb_location: tcbb_location,
                    tcbb_from: tcbb_from,
                    tfd_individual: individual_name,
                    tfd_individual_code: individual_id,

                    tfd_1type: selectedOption.value,
                    tfd_1line_no: tempLineNo,
                    tfd_1srno: 1,
                }
                setTempLineNo(tempLineNo + 1);
                Common.callApi(Common.apiBookEntry, [sid, 'addknockoffSingle', JSON.stringify(obj)], (result) => {
                    let resp = JSON.parse(result);
                })
            }
            if (userRight.edit === "1" && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, obj]);
            }
            setBookList(Common.arrayAddItem(bookList, obj));
            setCounter(counter + 1);
            setShowList(true);
            setAmount("");
            setFlag("C");
            setLedgerValue(null);
            setBankName("");
            setChequeNum("");
            setBankName("");
            setNIndividual(null);
            setChequeStatus(null);
            calculateTotal(bookList);
            setChequeDate(new Date());
            setMvgType("");
            setType('T');
            setKnockoffValue(null);
            setKnockoffType("");
            setKnockoffSrno("");
            setKnockoffAmt("");
        }
    }
    //console.log(bookList);
    const handleSave = () => {
        if (selectedOption.value === 'CS') {
            if (checkWalkinCashLimit()) {
                setMsgText("Not able to save, cannot add more than " + 50000 + " in walkin.");
                setMsgBox(true);
                return; // Stop
            }
        }
        let expectedAccountType;
        if (selectedOption.value === 'BK') {
            expectedAccountType = ['BANK', 'CHEQUE'];
            const hasForbiddenAccount = bookList.some(
                (entry) => ['CASH'].includes(entry.tfd_account_type)
            );
            if (hasForbiddenAccount && bookList.length > 0) {
                setMsgBox(true);
                setMsgText("Cannot add CASH in BK");
                return; // Stop 
            }
        } else if (selectedOption.value === 'CS') {
            expectedAccountType = ['CASH'];
        } else if (selectedOption.value === 'JV') {
            const hasForbiddenAccount = bookList.some(
                (entry) => ['BANK', 'CASH', 'CHEQUE'].includes(entry.tfd_account_type)
            );
            if (hasForbiddenAccount && bookList.length > 0) {
                setMsgText("No account should have type BANK , CHEQUE or CASH");
                setMsgBox(true);
                return; // Stop 
            } else {
                handleSaveData();
            }
        }
        if (expectedAccountType) {
            const hasExpectedAccount = bookList.some((entry) => {
                if (Array.isArray(expectedAccountType)) {
                    return expectedAccountType.includes(entry.tfd_account_type);
                } else {
                    return entry.tfd_account_type === expectedAccountType;
                }
            });

            if (!hasExpectedAccount && bookList.length > 0) {
                setMsgText(`At least one account should be of  '${expectedAccountType.join("' or '")}'`);
                setMsgBox(true);
                return; // Stop
            } else {
                handleSaveData();
            }
        }
    }

    const checkWalkinCashLimit = () => {
        let waliknamt = 0;
        for (let i = 0; i < bookList.length; i++) {
            if (bookList[i].tfd_account_type === "WALKIN") {
                waliknamt = waliknamt + Math.abs(bookList[i].tfd_amount) * 1;
            }
        }
        return waliknamt > 50000;
    }

    const handleSaveData = () => {
        var msg = [], i = 0;
        // if (bookList.length == '0') {
        //     setMsgText("You can't save without adding data");
        //     setMsgBox(true);
        // } else 
        if ((totalDifference != '0.00') || narration === "" || (narration.trim()).length < 45) {
            msg[i++] = ((totalDifference != '0.00') ? "Total Debit and Total Credit should be equal" : '');
            msg[i++] = (narration === "" ? "Please fill Narration." : '');
            msg[i++] = ((narration.trim()).length < 45 ? "Narration length should be a minimum of 45 characters." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (scrMode === 'E' && acRemark === '') {
            setShowModal(true);
        }

        else {
            const obj = {
                remark: acRemark,
                activitytype: srNo == 1 ? 'MODIFY' : 'CREATE',
                subtranno: code,
                trannumber: srNo,
                trantype: selectedOption.value,
                trancategory: 'T',
                branch: locationCode,

                location: locationCode,
                //date: Common.dateYMD(viewDate),
                date: (radioType == 'N' ? Common.dateYMD(filterDate) : viewDate.split('/').reverse().join('-')),
                type: selectedOption.value,
                narration: narration,
                bookList: bookList,
                radioType: radioType,
                scrMode: scrMode,
                srNo: srNo,
                totalCredit: totalCredit,
                totalDebit: totalDebit,
                chequeSrno: chequeSrno,
                chequeLine: chequeLine,
                chequeLocation: chequeLocation,
                chequeNum: chequeNum,
                randomString: randomString,
                knockoffValue: knockoffValue
            }
            $(".loader").show();
            Common.callApi(Common.apiBookEntry, [sid, 'saveBookEntry', JSON.stringify(obj), JSON.stringify(tranAuditTrail)], (result) => {
                //setBookList([]);
                $(".loader").hide();
                let resp = JSON.parse(result);
                if (resp.msg != "") {
                    setMsgBox(true);
                    setMsgText(resp.msg);
                } else {
                    setViewSrno(resp.srno);
                    setTranAuditTrail([])
                    if (radioType == 'N') {
                        setBookList(resp.resarray);
                        setSrNo(resp.srno);
                        setScrMode('Q');
                        setEditReqDate(Common.dateYMD(filterDate));
                    } else {
                        setNarration(narration);
                        setBookList(resp.resarray);
                        setScrMode('Q');
                    }
                }
                setChecked(false);
                setAddCount(0);
                setIndividualList(false);
                setAcRemark('');
                setCounter(counter + 1);
            });
            if (scrMode == 'E' && unlockRequestType !== "SELF") {
                const obj = {
                    srno: srNo,
                    type: selectedOption.value,
                    status: 'E',
                    currentDate: Common.dateYMD(currentDate),
                    pageright: 'TRAN_BOOK_ENTRY'
                }
                Common.callApi(Common.apiUnlockEdit, [sid, 'expireUnlock', JSON.stringify(obj)], (result) => {
                });

            }
        }
    }

    const handleShowList = () => {
        var msg = [], i = 0;
        if (selectedLocation === null || (radioType == 'S' && !srnoFrom) || (radioType == 'S' && !srnoTo) || (radioType == 'D' && !fromDate) || (radioType == 'D' && !toDate)) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (selectedLocation == null ? " Select location." : '');
            msg[i++] = (radioType == 'S' && !srnoFrom ? " From Srno." : '');
            msg[i++] = (radioType == 'S' && !srnoTo ? " To Srno." : '');
            msg[i++] = ((radioType == 'D' && !fromDate) ? " From date." : '');
            msg[i++] = ((radioType == 'D' && !toDate) ? " To date." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                date: Common.dateYMD(filterDate),
                type: selectedOption.value,
                location: locationCode,
                radioType: radioType,
                fromSrno: srnoFrom,
                toSrno: srnoTo,
                fromDate: Common.dateYMD(fromDate),
                toDate: Common.dateYMD(toDate)
            }
            $(".loader").show();
            Common.callApi(Common.apiBookEntry, [sid, 'showBookEntry', JSON.stringify(obj)], (result) => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                setHeaderList(resp);
                setShowHeaderList(true);
                setHidePreBtn(false);
                setHideNextBtn(false);
            });
        }
    }

    const handleView = (vsrno, vtype, vdate, vnarration, date) => {
        $(".loader").show();
        setEditReqDate(date);
        setRandomString(Common.getRandomString(15));
        setTempLineNo(1);
        setSelectedOption({
            value: vtype, label: vtype === "BK" ? "Bank Book" :
                vtype === "CS" ? 'Cash Book' :
                    vtype === "JV" ? "Journal Voucher" : ""
        });
        if (radioType == 'N') {
            setRadioType('A');
        }
        setSrNo(vsrno);
        const obj = {
            srNo: vsrno,
            location: locationCode,
            date: vdate,
            type: vtype,
            narration: vnarration,
            operation: 'view'
        }
        Common.callApi(Common.apiBookEntry, [sid, 'viewdata', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setBookList(resp);
            $(".loader").hide();
            setScrMode('Q');
            setShowHeaderList(false);
            setShowList(true);
            setViewSrno(vsrno);
            setViewDate(vdate);
            setViewType(vtype);
            setNarration(vnarration);
            calculateTotal(resp);
            setNIndividual(null);
            // setSelectedLocation(null);
        });
    }

    const viewNewEntry = (val) => {
        const newSrno = srNo * 1 + val;
        if (newSrno > 0) {
            const obj = {
                srNo: newSrno,
                location: locationCode,
                type: viewType,
            }
            Common.callApi(Common.apiBookEntry, [sid, 'viewdata', JSON.stringify(obj)], (result) => {
                let resp = JSON.parse(result);
                setBookList(resp);
                $(".loader").hide();
                setScrMode('Q');
                setShowHeaderList(false);
                setShowList(true);
                setViewSrno(newSrno);
                setSrNo(newSrno);
                setViewDate(resp[0]?.formatted_date || '');
                setViewType(viewType);
                setNarration(resp[0]?.tfh_narration || '');
                calculateTotal(resp);
                setNIndividual(null);
            });
        }

    }

    const calculateTotal = (list, src = "") => {
        // for (let i = 0; i < list.length; i++) {
        //     if (list[i].tfd_reftype != 'GB') {
        //     }
        // }
        // let totalDebt = totalDebit * 1;
        // let totalCred = totalCredit * 1;
        let totalDebt = 0;
        let totalCred = 0;
        let i;
        for (i = 0; i < list.length; i++) {
            let amt = 0;
            if (list[i].tfd_reftype != 'GB') {
                if (list[i].tfd_flag == 'D') {
                    if (list[i].tfd_amount < 0) {
                        amt = -1 * list[i].tfd_amount;
                    } else {
                        amt = list[i].tfd_amount;
                    }
                    totalDebt = totalDebt + amt * 1;
                } else {
                    if (list[i].tfd_amount > 0) {
                        amt = -1 * list[i].tfd_amount;
                    } else {
                        amt = list[i].tfd_amount;
                    }
                    totalCred += amt * 1;
                }
            }
        }
        setTotalDebit(totalDebt);
        setTotalCredit(totalCred);
        let totalDiff = totalDebt + totalCred;

        setTotalDifference(Number(totalDiff).toFixed(2));

        if (totalDiff < 0) {
            if (src === "") setFlag('D');
            setAmount(-1 * totalDiff);
        } else if (totalDiff == 0) {
            setAmount("");
        }
        else {
            if (src === "") setFlag('C');
            setAmount(totalDiff);
        }
    }

    const handleLedgerValue = (value) => {
        setLedgerValue(value);
        setViewAccount(value);
        const account = value.id.split('^');
        const groupCode = account[1];
        const accountType = account[4];
        setMvgType(accountType);
        setGrpCode(account[1]);
        setAccCode(account[2]);
        const obj = {
            groupCode: account[1],
            flag: flag == "C" ? "D" : "C"
        }
        Common.callApi(Common.apiBookEntry, [sid, "checkknockoff", JSON.stringify(obj)], result => {
            const res = JSON.parse(result);
            setIsKnockOff(res.isknockoff);
        });
        if (accountType == 'WALKIN') {
            setIndividualList(true);
            setChequeStatus(null);
        } else if (accountType == 'CHEQUE') {
            setFlag('D');
            setShowCheque(true);
            setNIndividual(null);
            setIndividualList(false);
            setChequeStatus("I");
        } else {
            setNIndividual(null);
            setIndividualList(false);
            setShowCheque(false);
            setChequeStatus(null);
        }
    }

    const handleClose = () => {
        setSelectiveTotalAmount(0);
        setShow(false);
        setShowKnockoff(true);
    }

    const handleKnockoffSelective = () => {
        var msg = [], i = 0;
        if (ledgerValue == null) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (ledgerValue == null ? "Please select account." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            let accountType;
            if (ledgerValue != null) {
                accountType = ledgerValue.id.split('^')[4];
            }
            const obj = {
                data: `${flag}^${grpCode}^${accCode}^${Common.dateYMD(filterDate)}^${randomString}`,
                limit: limit,
                srch: srch,
                accountType: accountType,
                location: locationCode
            }
            $(".loader").show();
            Common.callApi(Common.apiBookEntry, [sid, 'getknockoff', JSON.stringify(obj)], (result) => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                setKnockoffData(resp);
            });
            setShow(true);
            setShowKnockoff(false)
        }

    }

    const handleKnockoffValue = (value) => {
        setKnockoffValue(value);
        const knockoff = value.id.split('^');
        setKnockoffSrno(knockoff[3]);
        setKnockoffType(knockoff[2]);
        setKnockoffAmt(knockoff[6]);
        setKnockoffLineNo(knockoff[4]);
        setKnockoffPending(knockoff[8]);
        setKnockoffFlag(knockoff[9]);
        setKnockoffLedger(knockoff[10]);
        setPicklistIndividualCode(knockoff[11]);
        setPicklistIndividualName(knockoff[12]);
    }

    const updateKnockoffFields = (index, e, name) => {
        let tempArr = knockoffData.map((item, i) => {
            if (index === i) {
                if (name === "tfd_amount") {
                    if (item.ischecked === '1') {
                        let oldVal = parseFloat(item.tfd_amount || 0);
                        let newVal = parseFloat(e.target.value || 0);
                        let diff = newVal - oldVal;
                        setSelectiveTotalAmount(prev => prev + diff);
                    }

                    return { ...item, [name]: e.target.value };
                } else {
                    let amount = parseFloat(item.tfd_amount || 0);
                    if (e.target.checked) {
                        setSelectiveTotalAmount(prev => prev + amount);
                        return { ...item, [name]: '1', 'tfd_random_for_1lineno': Common.getRandomString(10) };
                    } else {
                        setSelectiveTotalAmount(prev => prev - amount);
                        return { ...item, [name]: '0', 'tfd_random_for_1lineno': "" };
                    }
                }
            } else {
                return item;
            }
        });
        setKnockoffData(tempArr);
    };

    function selectiveKnockoffCHeckHandler(e) {
        let tempArr = [];
        let knockoffAmount = 0;
        if (e.target.checked) {
            tempArr = knockoffData.map((item) => {
                let amount = parseFloat(item.tfd_amount || 0);
                knockoffAmount += amount;
                return { ...item, 'ischecked': '1', 'tfd_random_for_1lineno': Common.getRandomString(10) };
            })
        } else {
            tempArr = knockoffData.map((item) => {
                return { ...item, 'ischecked': '0', 'tfd_random_for_1lineno': Common.getRandomString(10) };
            })
            knockoffAmount = 0;

        }
        setSelectiveTotalAmount(knockoffAmount);
        setKnockoffData(tempArr);
    }

    //console.log(knockoffData);
    const handleAddKnockoff = () => {
        setSelectiveTotalAmount(0);
        var isOk = false;
        for (let i = 0; i < knockoffData.length; i++) {
            if (knockoffData[i].ischecked == "1") {
                isOk = true;
                // if (knockoffData[i].tfd_account_type === "WALKIN" && nIndividual === null) {
                //     isOk = false;
                //     setMsgBox(true);
                //     setMsgText("Individual is mandatory when WALKIN is picked.");
                //     setShow(false);
                //     return;
                // }
                if ((knockoffData[i].tfd_amount) * 1 > (knockoffData[i].tfd_pending_amount) * 1) {
                    isOk = false;
                    setMsgBox(true);
                    setMsgText("Entered amount can't be greater then pending amount. [Pending: " + knockoffData[i].tfd_pending_amount + ", Entered: " + knockoffData[i].tfd_amount + "].");
                    setShow(false);
                    return;
                }
            }
        }
        if (isOk) {
            const obj = {
                knockoffData: knockoffData,
                randomString: randomString,
                trantype: selectedOption.value
            }
            $(".loader").show();
            Common.callApi(Common.apiBookEntry, [sid, 'addknockoffSelective', JSON.stringify(obj)], (result) => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                setShow(false);
                setShowKnockoff(true);
                setCounter(counter + 1);
                setShowList(true);
                setLedgerValue(null);
                setNIndividual(null);
                for (let i = 0; i < resp.length; i++) {
                    resp[i].tfd_flag = resp[i].tfd_flag === "D" ? "C" : "D";
                }
                //calculateTotal(resp);
                setKnockoffValue(null);
                setKnockoffType("");
                setKnockoffSrno("");
                setKnockoffAmt("");
                let totalAmount = 0;
                //let amtCalcArr = [];
                var tempLineNo1 = tempLineNo + 1;
                for (let i = 0; i < knockoffData.length; i++) {
                    if (knockoffData[i].ischecked == "1") {
                        for (let k = 0; k < resp.length; k++) {
                            //resp[i].tfd_flag = resp[i].tfd_flag === "D" ? "C" : "D";
                            if (knockoffData[i].tfd_random_for_1lineno === resp[k].tfd_random_for_1lineno) {
                                knockoffData[i].uniquekey = Common.getRandomString(15);
                                knockoffData[i].tfd_transfer_type = "";
                                knockoffData[i].tfd_cheque_status = "";
                                knockoffData[i].cheque_date = "";
                                knockoffData[i].tfd_cheque_bank_name = "";
                                knockoffData[i].tfd_cheque_no = "";
                                knockoffData[i].tfd_account_type = "";
                                knockoffData[i].chequeValueNum = "";
                                knockoffData[i].tfd_flag = knockoffData[i].tfd_flag === "C" ? "D" : "C";
                                knockoffData[i].tfd_reftype = "";
                                totalAmount = totalAmount + knockoffData[i].tfd_amount * 1;
                                knockoffData[i].tfd_1srno = resp[k].tfd_1srno;
                                knockoffData[i].tfd_1line_no = resp[k].tfd_1line_no;

                                knockoffData[i].tfd_line_no = tempLineNo1;
                                knockoffData[i].tfd_type = resp[k].tfd_1type;

                                knockoffData[i].tfd_1type = resp[k].tfd_1type;
                                setBookList(Common.arrayAddItem(bookList, knockoffData[i]));
                                //setBookList(Common.arrayAddItem(bookList, resp[i])); 
                                tempLineNo1++;
                                break;
                            }
                        }
                    }
                }
                setTempLineNo(tempLineNo1);
                calculateTotal(bookList);
                // setFlag(flag === "C" ? "D" : "C");
                // setAmount(totalAmount);
            });
            // let totalAmount = 0;
            // for (let i = 0; i < knockoffData.length; i++) {
            //     knockoffData[i].tfd_transfer_type = "";
            //     knockoffData[i].tfd_cheque_status = "";
            //     knockoffData[i].cheque_date = "";
            //     knockoffData[i].tfd_cheque_bank_name = "";
            //     knockoffData[i].tfd_cheque_no = "";
            //     knockoffData[i].tfd_account_type = "";
            //     knockoffData[i].chequeValueNum = "";
            //     knockoffData[i].tfd_flag = knockoffData[i].tfd_flag === "C" ? "D" : "C";
            //     knockoffData[i].tfd_reftype = "";
            //     if (knockoffData[i].ischecked == '0') continue;
            //     totalAmount = totalAmount + knockoffData[i].tfd_amount * 1;
            //     setBookList(Common.arrayAddItem(bookList, knockoffData[i]));
            // }
        } else {
            setShow(false);
            setMsgText(" No value selected for knocking off ");
            setMsgBox(true);
        }

    }

    const handleAddKnockoffMultiple = () => {
        setSelectiveTotalAmount(0);
        var isOk = false;
        for (let i = 0; i < knockoffData.length; i++) {
            if (knockoffData[i].ischecked == "1") {
                isOk = true;
                // if (knockoffData[i].tfd_account_type === "WALKIN" && nIndividual === null) {
                //     isOk = false;
                //     setMsgBox(true);
                //     setMsgText("Individual is mandatory when WALKIN is picked.");
                //     setShow(false);
                //     return;
                // }
                if ((knockoffData[i].tfd_amount) * 1 > (knockoffData[i].tfd_pending_amount) * 1) {
                    isOk = false;
                    setMsgBox(true);
                    setMsgText("Entered amount can't be greater then pending amount. [Pending: " + knockoffData[i].tfd_pending_amount + ", Entered: " + knockoffData[i].tfd_amount + "].");
                    setShow(false);
                    return;
                }
            }
        }
        if (isOk) {
            const obj = {
                knockoffData: knockoffData,
                randomString: randomString,
                trantype: selectedOption.value
            }
            $(".loader").show();
            Common.callApi(Common.apiBookEntry, [sid, 'addknockoffSelective', JSON.stringify(obj)], (result) => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                // setShow(false);
                // setShowKnockoff(true);
                setCounter(counter + 1);
                // setShowList(true);
                // setLedgerValue(null);
                // setNIndividual(null);
                for (let i = 0; i < resp.length; i++) {
                    resp[i].tfd_flag = resp[i].tfd_flag === "D" ? "C" : "D";
                }
                calculateTotal(resp, "M");
                setKnockoffValue(null);
                setKnockoffType("");
                setKnockoffSrno("");
                setKnockoffAmt("");
                let totalAmount = 0;
                //let amtCalcArr = [];
                for (let i = 0; i < knockoffData.length; i++) {
                    if (knockoffData[i].ischecked == "1") {
                        for (let k = 0; k < resp.length; k++) {
                            //resp[i].tfd_flag = resp[i].tfd_flag === "D" ? "C" : "D";
                            if (knockoffData[i].tfd_random_for_1lineno === resp[k].tfd_random_for_1lineno) {
                                knockoffData[i].uniquekey = Common.getRandomString(15);
                                knockoffData[i].tfd_transfer_type = "";
                                knockoffData[i].tfd_cheque_status = "";
                                knockoffData[i].cheque_date = "";
                                knockoffData[i].tfd_cheque_bank_name = "";
                                knockoffData[i].tfd_cheque_no = "";
                                knockoffData[i].tfd_account_type = "";
                                knockoffData[i].chequeValueNum = "";
                                knockoffData[i].tfd_flag = knockoffData[i].tfd_flag === "C" ? "D" : "C";
                                knockoffData[i].tfd_reftype = "";
                                totalAmount = totalAmount + knockoffData[i].tfd_amount * 1;
                                knockoffData[i].tfd_1srno = resp[k].tfd_1srno;
                                knockoffData[i].tfd_1line_no = resp[k].tfd_1line_no;
                                knockoffData[i].tfd_1type = resp[k].tfd_1type;
                                setBookList(Common.arrayAddItem(bookList, knockoffData[i]));
                                //setBookList(Common.arrayAddItem(bookList, resp[i]));
                                break;
                            }
                        }
                    }
                }
                handleKnockoffSelective();
                //calculateTotal(resp);
                // setFlag(flag === "C" ? "D" : "C");
                // setAmount(totalAmount);
            });
            // let totalAmount = 0;
            // for (let i = 0; i < knockoffData.length; i++) {
            //     knockoffData[i].tfd_transfer_type = "";
            //     knockoffData[i].tfd_cheque_status = "";
            //     knockoffData[i].cheque_date = "";
            //     knockoffData[i].tfd_cheque_bank_name = "";
            //     knockoffData[i].tfd_cheque_no = "";
            //     knockoffData[i].tfd_account_type = "";
            //     knockoffData[i].chequeValueNum = "";
            //     knockoffData[i].tfd_flag = knockoffData[i].tfd_flag === "C" ? "D" : "C";
            //     knockoffData[i].tfd_reftype = "";
            //     if (knockoffData[i].ischecked == '0') continue;
            //     totalAmount = totalAmount + knockoffData[i].tfd_amount * 1;
            //     setBookList(Common.arrayAddItem(bookList, knockoffData[i]));
            // }
        } else {
            setShow(false);
            setMsgText(" No value selected for knocking off ");
            setMsgBox(true);
        }

    }

    const handleBack = () => {
        setScrMode('');
        setHidePreBtn(false);
        setHideNextBtn(false);
    }

    const handleCancel = () => {
        setMsgBoxYN(true);
        setMsgTextYN("Do you really want to exit");
    }

    const cancelData = () => {
        setScrMode('');
        setShowHeaderList(true);
        handleShowList();
        setChecked(false);
        setMsgBoxYN(false);
        //setSelectedOption({ value: "BK", label: 'Bank Book' });
        setAmount("");
        setLedgerValue(null);
        setNIndividual(null);
        setIndividualList(false);
    }

    const handleDelete = (obj) => {
        console.log(obj);
        // if (scrMode == 'E') {
        if (obj.tfd_knockoff_srno != null && obj.tfd_knockoff_srno > 0) {
            const object = {
                location: obj.tfd_location,
                type: obj.tfd_type,
                srno: srNo,
                lineno: obj.tfd_line_no,
                amt: obj.tfd_amount < 0 ? -1 * obj.tfd_amount : obj.tfd_amount,
                randomString: randomString,
                tfd_1type: obj.tfd_1type,
                tfd_1line_no: obj.tfd_1line_no,
                tfd_1srno: obj.tfd_1srno
            }
            $(".loader").show();
            Common.callApi(Common.apiBookEntry, [sid, 'canDelete', JSON.stringify(object)], (result) => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                if (resp.isdeletable == "0") {
                    setMsgBox(true);
                    setMsgText("Cannot delete, amount already knocked off.");
                } else {
                    const itemToDelete = bookList.find(item => item.uniquekey === obj.uniquekey);
                    if (itemToDelete) {
                        const formattedItem = {
                            TabType: "Info",
                            ALineNo: tranAuditTrail.length + 1,
                            AType: "D",
                            TLoc: locationCode,
                            TType: selectedOption.value,
                            tfd_date: itemToDelete.tfd_date,
                            type: itemToDelete.type,
                            tfd_type: itemToDelete.tfd_type,
                            tfd_flag: itemToDelete.tfd_flag,
                            tfd_amount: itemToDelete.tfd_amount,
                            tfd_group: itemToDelete.tfd_group,
                            tfd_account: itemToDelete.tfd_account,
                            tfd_account_type: itemToDelete.tfd_account_type,
                            mvli_ledger_name: itemToDelete.mvli_ledger_name,
                            srno: srNo,
                            tfd_individual: itemToDelete.tfd_individual,
                            tfd_cheque_no: itemToDelete.tfd_cheque_no,
                            tfd_cheque_bank_name: itemToDelete.tfd_cheque_bank_name,
                            tfd_cheque_status: itemToDelete.tfd_cheque_status,
                            chequeValueNum: chequeValueNum,
                            tfd_transfer_type: itemToDelete.tfd_transfer_type,
                            tcbb_srno: itemToDelete.tcbb_srno,
                            tcbb_line_no: itemToDelete.tcbb_line_no,
                            tcbb_location: itemToDelete.tcbb_location,
                            tcbb_from: itemToDelete.tcbb_from
                        };
                        if (userRight.edit === "1" && scrMode === 'E') {
                            setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, formattedItem]);
                        }
                    }
                    setBookList(Common.arrayRemoveItem(bookList, "uniquekey", obj.uniquekey));
                    setCounter(counter - 1);
                    calculateTotal(bookList);
                }
            });
        } else {
            const itemToDelete = bookList.find(item => item.uniquekey === obj.uniquekey);
            if (itemToDelete) {
                const formattedItem = {
                    TabType: "Info",
                    ALineNo: tranAuditTrail.length + 1,
                    AType: "D",
                    TLoc: locationCode,
                    TType: selectedOption.value,
                    tfd_date: itemToDelete.tfd_date,
                    type: itemToDelete.type,
                    tfd_type: itemToDelete.tfd_type,
                    tfd_flag: itemToDelete.tfd_flag,
                    tfd_amount: itemToDelete.tfd_amount,
                    tfd_group: itemToDelete.tfd_group,
                    tfd_account: itemToDelete.tfd_account,
                    tfd_account_type: itemToDelete.tfd_account_type,
                    mvli_ledger_name: itemToDelete.mvli_ledger_name,
                    srno: srNo,
                    tfd_individual: itemToDelete.tfd_individual,
                    tfd_cheque_no: itemToDelete.tfd_cheque_no,
                    tfd_cheque_bank_name: itemToDelete.tfd_cheque_bank_name,
                    tfd_cheque_status: itemToDelete.tfd_cheque_status,
                    chequeValueNum: chequeValueNum,
                    tfd_transfer_type: itemToDelete.tfd_transfer_type,
                    tcbb_srno: itemToDelete.tcbb_srno,
                    tcbb_line_no: itemToDelete.tcbb_line_no,
                    tcbb_location: itemToDelete.tcbb_location,
                    tcbb_from: itemToDelete.tcbb_from
                };
                if (userRight.edit === "1" && scrMode === 'E') {
                    setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, formattedItem]);
                }
            }
            setBookList(Common.arrayRemoveItem(bookList, "uniquekey", obj.uniquekey));
            setCounter(counter - 1);
            calculateTotal(bookList);
        }
    }


    const handleChange = value => {
        setSelectedLocation(value);

        const loc = value.id.split('^');
        setLocationCode(loc[1]);
        setLocation(loc[2]);
        sessionStorage.activeBranch = loc[1];
        setIsBranchDisableForAddNew(loc[9]);

    }

    const handleChequeNum = value => {
        setChequeValue(value);

        const cheque = value.id.split('^');
        setChequeNum(cheque[4]);
        setChequeValueNum(cheque[4]);
        setChequeSrno(cheque[1]);
        setChequeLine(cheque[2]);
        setChequeLocation(cheque[3]);
        //setChequeDate(cheque[5]);
        setChequeDate(new Date());

    }

    const newIndividual = () => {
        setShowIndividualForm(true);
    }

    const handleNewIndiviualChange = (value) => {

        setNIndividual(value);
        if (nCorporate == null) {
            setNState({ value: faStateValue, label: faStateName });
        }
    }

    const hideIndividualProfile = (val, individualsrno, blacklistedYN, master, dataid, name) => {
        setShowIndividualForm(val);
        if (blacklistedYN == '1') {
            setMsgText(name + " saved with Red Flags individual." + master + " " + dataid);
            setMsgBox(true);
            setNIndividual(null);
            return;
        }
        if (individualsrno > 0) {
            Common.callApi(Common.apiBookEntry, [sid, "individual", individualsrno], result => {
                let resp = JSON.parse(result);
                setNIndividual(resp);
            });
        }
    }

    const handleFlagChange = (e) => {
        setFlag(e.target.value);
        const selectedFlag = e.target.value;
        if (ledgerValue != null) {
            const account = ledgerValue.id.split('^');
            if (account[4] == 'CHEQUE' && selectedFlag == 'C') {
                setMsgText("'CHEQUE'can not be Credit");
                setMsgBox(true);
                setFlag('D')
            }
        }
    }

    // Fa book print ==============================================
    const handleDownload = (printFlag) => {
        $(".loader").show();
        const obj = {
            srno: srNo,
            location: locationCode,
            faType: selectedOption.value,
            printFlag: printFlag,
            type: 'FAP',
        }
        Common.callApi(Common.apiPrint, [sid, "print", JSON.stringify(obj)], result => {
            $(".loader").hide();
            var newWindow = window.open();
            newWindow.document.write(result);
        });
    }
    const handleReset = () => {
        setNIndividual(null);
    }

    const btnSaveModal = () => {
        if (scrMode === 'E' && acRemark === '') {
            setShowModal(false);
            setMsgText('Please fill Activity Remark!');
            setMsgBox(true);
        } else {
            handleSaveData();
            setShowModal(false);
        }
    }

    const btnActivityLog = () => {
        setShowActivityLog(true);
        setLogObject({ trantype: selectedOption.value, trannumber: srNo, trancategory: "T", location: locationCode, subtranno: code });
    }

    const btnEditRequest = () => {
        const currDate = new Date();
        const newViewDate = editReqDate;
        const newCurrDate = Common.dateYMD(currDate);

        // console.log(newViewDate);
        // console.log(newCurrDate);
        const dateA = new Date(editReqDate);
        const dateB = new Date(newCurrDate);
        dateA.setHours(0, 0, 0, 0);
        dateB.setHours(0, 0, 0, 0);
        // Calculate the difference in milliseconds
        const differenceInMilliseconds = dateB - dateA;

        // Convert milliseconds difference to days
        const differenceInDays = Math.abs(differenceInMilliseconds / (1000 * 3600 * 24));
        console.log(differenceInDays);

        const obj = {
            srno: srNo === 0 ? viewSrno : srNo,
            type: selectedOption.value,
            pageright: 'TRAN_BOOK_ENTRY',
            location: locationCode
        }
        // const message = 'unlock'
        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (Common.editDateLimit >= differenceInDays || resp.msg == "unlock") {
                setScrMode('E');

            } else {
                setShowEditRequest(true);
                setEditLogObject({ trantype: selectedOption.value, trannumber: viewSrno == 0 ? srNo : viewSrno, location: locationCode, tranDate: Common.dateYMD(currDate) });
            }
        })
    }

    const uploadFile = () => {
        $('.loader').show();
        var isOk = true;

        if (isOk && selectedOption.value === "CS" && uploadCSRight.add != '1') {
            $('.loader').hide();
            isOk = false;
            setMsgText("Only Bank Voucher and JV can be uploaded.");
            setMsgBox(true);
        }
        if (isOk) {
            if (document.getElementById('importExcel').files[0] === undefined) {
                $('.loader').hide();
                setMsgText("Please select a file to upload.");
                setMsgBox(true);
            } else {
                var tempArray = document.getElementById('importExcel').files[0].name.split('.');
                if (tempArray.length > 2) {
                    $('.loader').hide();
                    setMsgText("(.) not allowed in file name.");
                    setMsgBox(true);
                } else if (document.getElementById('importExcel').files[0].size > 10 * 1024 * 1024) {  // 10 MB
                    $('.loader').hide();
                    setMsgText("Please select a file with in 10 MB size.");
                    setMsgBox(true);
                } else if (tempArray[1] != 'xlsx') {
                    $('.loader').hide();
                    setMsgText("File extension should be in xlsx format");
                    setMsgBox(true);
                }
                else {
                    const obj = {
                        // loc: locationCode,
                        srno: 8888,
                        uploadType: selectLocationtype.value === "O" ? "uploadFABook" : "uploadFABookMultiLocation",
                        pageright: "TRAN_BOOK_UPLOAD",
                        type: selectedOption.value,
                        loc: locationCode,
                        sid: sid,
                        // radioType :'S',
                        // fromSrno: srnoFrom,
                        // toSrno: srnoTo,
                    }
                    Common.uploadApi(JSON.stringify(obj), 'importExcel', (result) => {
                        $('.loader').hide();
                        let resp = JSON.parse(result);
                        console.log(resp);
                        if (resp.status) {
                            setFile('');
                            setHeaderList(resp.docdetail);
                            setShowHeaderList(true);
                            setShowUploadOption(false);
                        }
                        setMsgBox(true);
                        setMsgText(resp.msg);
                    });
                }
            }
        }

    }

    function demoFAformatfile() {
        $(".loader").show();
        const obj = {
            location: locationCode,
            right: 'TRAN_BOOK_UPLOAD',
            locationFlag: selectLocationtype.value,
        }
        Common.callDownloadApiPost1(Common.apiBookEntry, "post", [sid, 'downloadformat', JSON.stringify(obj)], (result) => {
            $(".loader").hide();
            setMsgText(Common.buildMessageFromArray([result]));
            setMsgBox(true);
        })
    }


    const handleCancelBill = () => {
        const currDate = new Date();
        const newViewDate = editReqDate;
        const newCurrDate = Common.dateYMD(currDate);

        // console.log(newViewDate);
        // console.log(newCurrDate);
        const dateA = new Date(editReqDate);
        const dateB = new Date(newCurrDate);
        dateA.setHours(0, 0, 0, 0);
        dateB.setHours(0, 0, 0, 0);
        // Calculate the difference in milliseconds
        const differenceInMilliseconds = dateB - dateA;

        // Convert milliseconds difference to days
        const differenceInDays = Math.abs(differenceInMilliseconds / (1000 * 3600 * 24));
        console.log(differenceInDays);

        const obj = {
            srno: srNo === 0 ? viewSrno : srNo,
            type: selectedOption.value,
            pageright: 'TRAN_BOOK_ENTRY',
            location: locationCode
        }
        // const message = 'unlock'
        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (Common.editDateLimit >= differenceInDays || resp.msg == "unlock") {
                setMsgTextYNBillDelete("Are you sure.");
                setMsgBoxYNBillDelete(true);
            } else {
                setShowEditRequest(true);
                setEditLogObject({ trantype: selectedOption.value, trannumber: viewSrno == 0 ? srNo : viewSrno, location: locationCode, tranDate: Common.dateYMD(currDate) });
            }
        })
    }
    const handleDeleteBill = (remark) => {
        setMsgBoxYNBillDelete(false);
        const obj = {
            type: selectedOption.value,
            location: locationCode,
            srno: srNo,
            productList: [],
            remark: remark,
        }
        Common.callApi(Common.apideletebill, [sid, 'deletebill', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            if (resp.err == "") {
                setScrMode("");
                handleShowList();
                setMsgText(resp.msg);
                setMsgBox(true);
            } else {
                setMsgText(resp.msg);
                setMsgBox(true);
            }
        })
    }
    function faTypeChangeHandler(e) {
        setSelectedOption(e)
        setShowUploadOption(false);
        setFile(null);
        // set 
    }
    const copyNarrationValue = (location, type, srno, lineno) => {
        const obj = {
            location: location,
            type: type,
            srno: srno,
            lineno: lineno
        }
        Common.callApi(Common.apiBookEntry, [sid, 'copynarration', JSON.stringify(obj)], (result) => {
            navigator.clipboard.writeText(JSON.parse(result) || '');
        })
    }

    function locationTypeHandler(e) {
        setSelectLocationtype(e);
    }

    return (
        <>

            {/* {
                displayFlag === 'P' ?
                    <>
                        <Tran_fa_book_print srno={srNo} location={locationCode} type={selectedOption.value} hidePrint={hidePrint} />
                    </>
                    : displayFlag === 'A' ?
                        <>
                            <Tran_fa_book_print_advance srno={srNo} location={locationCode} type={selectedOption.value} hidePrint={hidePrint} />
                        </>
                        :
                        <> */}
            {
                showIndividualForm ?
                    <Master_individual_profile reqObj={{ nIndivual: nIndividual, scrIndividual: 'A' }} value="FABOOK" hideIndividualProfile={hideIndividualProfile} />
                    : <>
                        <LoginHeader />
                        <Menu />
                        <Container fluid>

                            <Row>
                                <Col>
                                    <h2>FA Book Entry  <span style={{ color: 'white' }}>{counter}</span></h2>
                                </Col>
                            </Row>
                            &nbsp;
                            {
                                scrMode == '' ?
                                    <>
                                        <Row>

                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                                    <AsyncSelect
                                                        cacheOptions={false}
                                                        defaultOptions={false}
                                                        value={selectedLocation}
                                                        getOptionLabel={e => e.label + ' '}
                                                        getOptionValue={e => e.id}
                                                        loadOptions={Picklist.fetchLocationAllowedPicklist}
                                                        onInputChange={Picklist.handleInputChange}
                                                        onChange={(e) => handleChange(e)}
                                                        isDisabled={branchDisable === "true"}
                                                    >
                                                    </AsyncSelect>
                                                </Form.Group>
                                            </Col>

                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>FA Type<span className="text-danger">*</span></Form.Label>
                                                    <Select value={selectedOption} onChange={(e) => faTypeChangeHandler(e)} options={options} />
                                                </Form.Group>
                                            </Col>

                                            <Col className='col-md-4 col-6'>
                                                <Form.Group>
                                                    <Row style={{ marginTop: "30px" }}>
                                                        <Col>
                                                            <Form.Check checked={radioType === "N"} onChange={() => setRadioType("N")} type='radio' label="New" selected />
                                                        </Col>
                                                        <Col>
                                                            <Form.Check checked={radioType === "S"} onChange={() => setRadioType("S")} type='radio' label="SrNo" />
                                                        </Col>
                                                        <Col>
                                                            <Form.Check checked={radioType === "D"} onChange={() => setRadioType("D")} type='radio' label="Date" />
                                                        </Col>
                                                    </Row>
                                                </Form.Group>
                                            </Col>
                                        </Row>&nbsp;
                                        <Row>
                                            {
                                                radioType === "N" ?
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Date<span className="colorThemeRed">*</span></Form.Label><br />
                                                            <DatePicker className="form-control"
                                                                selected={filterDate}
                                                                onChange={(date) => setFilterDate(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                useShortMonthInDropdown
                                                                dropdownMode="select"
                                                                placeholder="dd/mm/yyyy"
                                                                peekNextMonth
                                                                // maxDate={new Date()}
                                                                customInput={
                                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    : radioType === "S" ?
                                                        <>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                                    <Form.Control value={srnoFrom}
                                                                        onChange={(e) => Common.validateNumValue(e.target.value, setSrnoFrom)}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                                    <Form.Control value={srnoTo}
                                                                        onChange={(e) => Common.validateNumValue(e.target.value, setSrnoTo)}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </>
                                                        : radioType === "D" ?
                                                            <>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>From Date<span className="colorThemeRed">*</span></Form.Label><br />
                                                                        <DatePicker className="form-control"
                                                                            selected={fromDate}
                                                                            onChange={(date) => setFromDate(date)}
                                                                            dateFormat="dd/MM/yyyy"
                                                                            showYearDropdown
                                                                            showMonthDropdown
                                                                            useShortMonthInDropdown
                                                                            dropdownMode="select"
                                                                            peekNextMonth
                                                                            customInput={
                                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                            }
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>To Date<span className="colorThemeRed">*</span></Form.Label><br />
                                                                        <DatePicker className="form-control"
                                                                            selected={toDate}
                                                                            onChange={(date) => setToDate(date)}
                                                                            dateFormat="dd/MM/yyyy"
                                                                            showYearDropdown
                                                                            showMonthDropdown
                                                                            useShortMonthInDropdown
                                                                            dropdownMode="select"
                                                                            peekNextMonth
                                                                            customInput={
                                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                            }
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                            </>
                                                            : null
                                            }
                                        </Row>&nbsp;

                                        <Row>
                                            <Col>
                                                {radioType == 'N' ?
                                                    <>
                                                        <Row>
                                                            <Col>
                                                                <Button variant='outline-success' className='buttonStyle' size='sm'
                                                                    onClick={handleAddNew}>Add New
                                                                </Button>&nbsp;
                                                                {/* {selectedOption.value + ' ' + uploadRight.add} */}
                                                                {
                                                                    /* && selectedOption.value != "CS" */
                                                                    ((selectedOption.value != "CS" && uploadRight.add === '1') || (selectedOption.value === "CS" && uploadCSRight.add === '1')) && <Button variant='outline-success' className='buttonStyle' size='sm'
                                                                        onClick={() => setShowUploadOption(true)}>Upload
                                                                    </Button>
                                                                }
                                                            </Col>
                                                        </Row>
                                                        &nbsp;
                                                        {showUploadOption ?
                                                            <Row>
                                                                {uploadMultilocationRight?.add === '1' &&
                                                                    <Col className='col-md-3 col-6'>
                                                                        <Form.Group>
                                                                            <Form.Label>Location Type<span className="text-danger">*</span></Form.Label>
                                                                            <Select value={selectLocationtype} onChange={(e) => locationTypeHandler(e)} options={locationOptionsType} />
                                                                        </Form.Group>
                                                                    </Col>
                                                                }
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group controlId="importExcel">
                                                                        <Form.Label>Upload File<span className="text-danger">*</span></Form.Label>
                                                                        <Form.Control type="file" value={file} onChange={e => setFile(e?.target?.value)} />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Row>&nbsp;</Row>
                                                                <Row>
                                                                    <Col>
                                                                        <span>
                                                                            <Badge bg="secondary" className="handCursor" onClick={() => { demoFAformatfile() }}>FA Upload Formate<FontAwesomeIcon icon={faDownload} /></Badge>&nbsp;
                                                                            {/* <Badge bg="secondary" className="handCursor" onClick={() => { demoFAformatfile() }}>FA Upload One Location<FontAwesomeIcon icon={faDownload} /></Badge> */}
                                                                        </span><br></br> <br></br>
                                                                        <Button variant="outline-success" className='buttonStyle' size='sm' onClick={() => uploadFile()}>Upload</Button>{' '}
                                                                    </Col>
                                                                </Row>
                                                            </Row>
                                                            : null
                                                        }
                                                    </>
                                                    :
                                                    <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={handleShowList}>
                                                        List
                                                    </Button>
                                                }
                                            </Col>
                                        </Row>
                                        <Row>&nbsp;</Row>
                                        {
                                            showHeaderList &&
                                            <Row>
                                                <Col>
                                                    <Table striped bordered hover>
                                                        <thead>
                                                            <tr>
                                                                {userRight.query === "1" ? <th></th> : null}
                                                                <th>Srno.</th>
                                                                <th>Type</th>
                                                                <th>Date</th>
                                                                <th>Total Debit</th>
                                                                <th>Total Credit</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {headerList.map((res) =>
                                                                <tr key={res.tfd_line_no}>
                                                                    {userRight.query === "1" ?
                                                                        <td className="textCenter" >
                                                                            {
                                                                                <span className="handCursor"
                                                                                    onClick={() => handleView(res.tfh_srno, res.tfh_type, res.formatted_date, res.tfh_narration, res.tfh_date)}
                                                                                >
                                                                                    <div className="colorThemeBlue"><FontAwesomeIcon icon={faEye} /></div>
                                                                                </span>
                                                                            }
                                                                        </td>
                                                                        : null
                                                                    }
                                                                    <td>{res.tfh_srno}</td>
                                                                    <td>{res.tfh_type}</td>
                                                                    <td>{res.formatted_date}</td>
                                                                    <td>{res.tfh_total_debit}</td>
                                                                    <td>{res.tfh_total_credit * -1}</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                        }
                                    </>
                                    :
                                    <>
                                        <Row>
                                            <Col >
                                                {scrMode == 'A' || scrMode == 'E' ?
                                                    <Button variant='outline-danger' className='buttonStyle' size='sm' onClick={handleCancel} >Cancel</Button>
                                                    : <Button variant='outline-danger' className='buttonStyle' size='sm' onClick={handleBack}>Back</Button>
                                                }&nbsp;
                                                {
                                                    (userRight.edit === "1" && scrMode === 'Q') ?
                                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                            btnEditRequest()}>Edit</Button>
                                                        : null
                                                }
                                                {
                                                    (userRight.query === "1" && scrMode === 'Q') ? <>
                                                        <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() =>
                                                            handleDownload("P")}>Print</Button>
                                                        {
                                                            sessionStorage.getItem('userSrno') == "1" &&
                                                            <>&nbsp;
                                                                <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                                    handleDownload("A")}>Advance
                                                                </Button>
                                                            </>
                                                        }
                                                    </> : null
                                                }
                                                {
                                                    (userRight.query === "1" && (scrMode === 'E' || scrMode === 'Q')) ? <>
                                                        &nbsp;
                                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                            btnActivityLog()}>Activity Log</Button>
                                                    </> : null
                                                }
                                                {
                                                    (userRight.query === "1" && scrMode === 'Q') &&
                                                    <>&nbsp;
                                                        <Button variant='outline-success' className='buttonStyle' size='sm'
                                                            onClick={handleAddNew}>Add New
                                                        </Button>
                                                    </>
                                                }
                                                {
                                                    (userRight.edit === "1" && scrMode === 'E') || (userRight.add === "1" && scrMode === 'A') ?
                                                        <>&nbsp;
                                                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleSave} >Save</Button>
                                                        </>
                                                        : null
                                                }
                                                {
                                                    (scrMode === "Q" && userCancelBillRight.query === "1") &&
                                                    <>
                                                        &nbsp;
                                                        <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => handleCancelBill()}>Cancel Bill</Button>
                                                    </>
                                                }
                                                {
                                                    !hideNextBtn && scrMode === "Q" &&
                                                    <>
                                                        &nbsp;
                                                        <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => viewNewEntry(-1)}>Previous</Button>
                                                    </>
                                                }
                                                {
                                                    !hidePrevBtn && scrMode === "Q" &&
                                                    <>
                                                        &nbsp;
                                                        <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => viewNewEntry(1)}>Next</Button>
                                                    </>
                                                }

                                            </Col>
                                        </Row>&nbsp;
                                        <Row>
                                            {/* { */}
                                            {/* // srNo > 0 && */}
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>FA Type<span className="text-danger">*</span></Form.Label>
                                                    <Select value={selectedOption} onChange={(e) => setSelectedOption(e)} options={options} isDisabled={scrMode !== "A"} />
                                                </Form.Group>
                                            </Col>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>SrNo : {viewSrno}</Form.Label>
                                                </Form.Group>
                                            </Col>
                                            {/* <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Type : {viewType}</Form.Label>
                                                </Form.Group>
                                            </Col> */}
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Location : {location}</Form.Label>
                                                </Form.Group>
                                            </Col>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Date : {viewDate}</Form.Label>
                                                </Form.Group>
                                            </Col>

                                        </Row>
                                        &nbsp;

                                        {scrMode == 'E' || scrMode == 'A' ?
                                            <>
                                                <Row>

                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Cr/Dr<span className="text-danger">*</span></Form.Label>
                                                            <Form.Select value={flag} onChange={(e) => handleFlagChange(e)} required>
                                                                <option value="C">Credit</option>
                                                                <option value="D">Debit</option>
                                                            </Form.Select>
                                                            {/* <Select value={flag} onChange={(e) => setFlag(e)} options={flagOptions} isSearchable={false} /> */}
                                                        </Form.Group>

                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='col-md-9 col-12'>
                                                        <Form.Group>
                                                            <Form.Label>Account<span className="text-danger">*</span></Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={ledgerValue}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={(search) => Picklist.fetchLedgerAllowedWithGroupPicklist(search, locationCode)} // location = 1 , 2
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handleLedgerValue}
                                                                formatOptionLabel={Picklist.accountFormatOptionLabel}
                                                                components={{ Menu: Picklist.accountMenu }}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Amount<span className="text-danger">*</span></Form.Label>
                                                            <Form.Control
                                                                value={amount}
                                                                maxLength={Common.maximumLength}
                                                                onChange={(e) => Common.validateDecValue(e.target.value, setAmount)}
                                                                placeholder="Amount"
                                                                disabled={!showKnockoff}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>


                                                {(showKnockoff && isKnockOff === "1") &&
                                                    <Row>
                                                        <Col className='col-12'>
                                                            <Form.Group>
                                                                <Form.Label>Knockoff<span className="text-danger">*</span></Form.Label>
                                                                <AsyncSelect
                                                                    cacheOptions={false}
                                                                    defaultOptions={false}
                                                                    value={knockoffValue}
                                                                    getOptionLabel={e => e.label + ' '}
                                                                    getOptionValue={e => e.id}
                                                                    loadOptions={(search) => Picklist.fetchKnockoffPicklist(search, locationCode, `${flag}^${grpCode}^${accCode}^${Common.dateYMD(filterDate)}^${randomString}`)} // location = 1 , 2
                                                                    onInputChange={Picklist.handleInputChange}
                                                                    onChange={handleKnockoffValue}
                                                                    formatOptionLabel={Picklist.knockOffFormatOptionLabel}
                                                                    components={{ Menu: Picklist.knockkOffMenu }}
                                                                >
                                                                </AsyncSelect>
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                }


                                                {
                                                    isKnockOff === "1" &&
                                                    <Row>
                                                        <Col className='col-md-3 col-6'>
                                                            <Button variant="outline-primary" onClick={handleKnockoffSelective}>
                                                                Selective Knockoff
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                }

                                                <Modal show={show} onHide={handleClose} size='xl'>
                                                    <Modal.Header closeButton>
                                                        <Modal.Title>Selective Knockoff</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <Row>
                                                            <Col className='col-md-3 '>
                                                                <Form.Label>Search</Form.Label>
                                                                <Form.Control
                                                                    value={srch}
                                                                    maxLength={500}
                                                                    placeholder="Search"
                                                                    onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setSrch)}
                                                                    onBlur={handleKnockoffSelective}
                                                                />
                                                            </Col>&nbsp;
                                                            <Col className='col-md-3 '>
                                                                <Form.Label>Limit</Form.Label>
                                                                <Form.Select value={limit} onChange={(e) => setLimit(e.target.value)} required>
                                                                    <option value="100">100</option>
                                                                    <option value="50">50</option>
                                                                    <option value="20">20</option>
                                                                    <option value="15">15</option>
                                                                    <option value="10">10</option>
                                                                </Form.Select>
                                                            </Col>&nbsp;

                                                            <Col className='col-md-4 mx-auto d-flex justify-content-evenly align-items-center'>
                                                                {/* <div> */}
                                                                <Button variant="outline-primary" onClick={handleKnockoffSelective}>
                                                                    Search
                                                                </Button>&nbsp;
                                                                {/* </div>
                                                                <div> */}
                                                                <Button variant="primary" onClick={handleAddKnockoff}>
                                                                    Add
                                                                </Button>&nbsp;
                                                                <Button variant="primary" onClick={() => handleAddKnockoffMultiple()}>
                                                                    Add Multiple
                                                                </Button>&nbsp;
                                                                <Button variant="secondary" onClick={handleClose}>
                                                                    Close
                                                                </Button>&nbsp;
                                                                {/* </div> */}
                                                            </Col>
                                                            <Col className='col-md-2 '>
                                                                <Form.Label>Total : {selectiveTotalAmount}</Form.Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Table striped bordered hover>
                                                                    <thead>
                                                                        <tr>
                                                                            <th>
                                                                                <td> <Form.Check
                                                                                    type="checkbox"
                                                                                    // checked=
                                                                                    name="ischecked"
                                                                                    onChange={(e) => selectiveKnockoffCHeckHandler(e)}
                                                                                /></td>
                                                                            </th>
                                                                            <th>Pending</th>
                                                                            <th>Type</th>
                                                                            <th>Date</th>
                                                                            <th>Total Amount</th>
                                                                            <th>Adjusted Amount</th>
                                                                            {/* <th>Group</th>
                                                                            <th>Account</th>
                                                                            <th>Name</th> */}
                                                                            <th>Individual</th>
                                                                            <th>Narration</th>

                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {knockoffData.map((res, index) =>
                                                                            <tr key={index}>
                                                                                <td> <Form.Check
                                                                                    type="checkbox"
                                                                                    checked={res.ischecked == '1'}
                                                                                    name="ischecked"
                                                                                    onChange={(e) => updateKnockoffFields(index, e, "ischecked")}
                                                                                /></td>
                                                                                <td> <Form.Control value={res.tfd_amount} name='tfd_amount'
                                                                                    onChange={(e) => updateKnockoffFields(index, e, "tfd_amount")}
                                                                                /></td>
                                                                                <td>{res.tfd_knockoff_type} {res.tfd_knockoff_srno}</td>
                                                                                <td>{res.tfd_date}</td>
                                                                                <td>{res.total_amount}</td>
                                                                                <td>{res.knockoff_amount}</td>
                                                                                {/* <td>{res.tfd_group}</td>
                                                                                <td>{res.tfd_account}</td>
                                                                                <td>{res.mvli_ledger_name}</td> */}
                                                                                <td>{res.individual_full_name}&nbsp;{res.tfd_reftype}&nbsp;{res.tfd_refnumber}</td>
                                                                                <td>{res.tfd_narration}</td>
                                                                            </tr>
                                                                        )}
                                                                    </tbody>
                                                                </Table>
                                                            </Col>
                                                        </Row>


                                                    </Modal.Body>
                                                    <Modal.Footer>
                                                        <Button variant="secondary" onClick={handleClose}>
                                                            Close
                                                        </Button>
                                                        <Button variant="primary" onClick={handleAddKnockoff}>
                                                            Add
                                                        </Button>
                                                        <Button variant="primary" onClick={() => handleAddKnockoffMultiple()}>
                                                            Add Multiple
                                                        </Button>
                                                    </Modal.Footer>
                                                </Modal>
                                                <Row>
                                                    {mvgType == 'BANK' &&
                                                        <Col className='col-md-3 col-6'>
                                                            <Form.Group>
                                                                <Form.Label>Type<span className="text-danger">*</span></Form.Label>
                                                                <Form.Select value={type} onChange={(e) => setType(e.target.value)} required>
                                                                    <option value="T">Transfer/Ref No.</option>
                                                                    <option value="C">Cheque</option>
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col>
                                                    }
                                                    {
                                                        mvgType == "CHEQUE" ?
                                                            <>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>Cheque Number<span className="text-danger">*</span></Form.Label>
                                                                        <Form.Control
                                                                            value={chequeNum}
                                                                            maxLength={Common.maximumLength}
                                                                            onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setChequeNum)}
                                                                            placeholder={mvgType == 'CHEQUE' || mvgType == 'BANK' && type == 'C' ? 'Cheque Number' : 'Reference Number'}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>Bank Name<span className="text-danger">*</span></Form.Label>
                                                                        <Form.Control
                                                                            value={bankName}
                                                                            maxLength={100}
                                                                            onChange={(e) => Common.validateAlpValue(e.target.value, setBankName)}
                                                                            placeholder="Bank Name"
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>Cheque Date<span className="text-danger">*</span></Form.Label><br />
                                                                        <DatePicker className="form-control"
                                                                            selected={chequeDate}
                                                                            onChange={(date) => setChequeDate(date)}
                                                                            dateFormat="dd/MM/yyyy"
                                                                            showYearDropdown
                                                                            showMonthDropdown
                                                                            useShortMonthInDropdown
                                                                            dropdownMode="select"
                                                                            placeholder="dd/mm/yyyy"
                                                                            peekNextMonth
                                                                            customInput={
                                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                            }
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                            </> : mvgType == "BANK" ?
                                                                <> <Col className='col-md-3 col-6'>
                                                                    <Form.Group>

                                                                        {
                                                                            flag == 'C' && type == 'T' &&
                                                                            <>
                                                                                <Form.Label>Reference Number<span className="text-danger">*</span></Form.Label>
                                                                                <Form.Control
                                                                                    value={chequeNum}
                                                                                    maxLength={255}
                                                                                    onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setChequeNum)}
                                                                                    placeholder="Reference Number"
                                                                                />
                                                                            </>

                                                                        }

                                                                        {
                                                                            flag == 'C' && type == 'C' &&
                                                                            <>
                                                                                <Form.Label>Cheque Number<span className="text-danger">*</span></Form.Label>
                                                                                <AsyncSelect
                                                                                    cacheOptions={false}
                                                                                    defaultOptions={false}
                                                                                    value={chequeValue}
                                                                                    getOptionLabel={e => e.label + ' '}
                                                                                    getOptionValue={e => e.id}
                                                                                    loadOptions={(search) => Picklist.fetchChequeBookBankPicklist(search, grpCode, accCode, locationCode)}
                                                                                    onInputChange={Picklist.handleInputChange}
                                                                                    onChange={(e) => handleChequeNum(e)}
                                                                                >
                                                                                </AsyncSelect>
                                                                            </>
                                                                        }

                                                                        {
                                                                            flag == 'D' && type == 'T' &&
                                                                            <>
                                                                                <Form.Label>Reference Number<span className="text-danger">*</span></Form.Label>
                                                                                <Form.Control
                                                                                    value={chequeNum}
                                                                                    maxLength={100}
                                                                                    onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setChequeNum)}
                                                                                    placeholder="Reference Number"
                                                                                />
                                                                            </>
                                                                        }&nbsp;

                                                                        {
                                                                            flag == 'D' && type == 'C' &&
                                                                            <>
                                                                                <Form.Label>Cheque Number<span className="text-danger">*</span></Form.Label>
                                                                                <AsyncSelect
                                                                                    cacheOptions={false}
                                                                                    defaultOptions={false}
                                                                                    value={chequeValue}
                                                                                    getOptionLabel={e => e.label + ' '}
                                                                                    getOptionValue={e => e.id}
                                                                                    loadOptions={(search) => Picklist.fetchChequeBookBankPicklist(search, grpCode, accCode, locationCode)}
                                                                                    onInputChange={Picklist.handleInputChange}
                                                                                    onChange={(e) => handleChequeNum(e)}
                                                                                >
                                                                                </AsyncSelect>
                                                                            </>
                                                                        }&nbsp;
                                                                    </Form.Group>
                                                                </Col>

                                                                    {flag == 'D' && type == 'C' &&
                                                                        <Col className='col-md-3 col-6'>
                                                                            <Form.Group>
                                                                                <Form.Label>Bank Name<span className="text-danger">*</span></Form.Label>
                                                                                <Form.Control
                                                                                    value={bankName}
                                                                                    maxLength={100}
                                                                                    onChange={(e) => Common.validateAlpValue(e.target.value, setBankName)}
                                                                                    placeholder="Bank Name"
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                    }&nbsp;
                                                                </>
                                                                : null
                                                    }

                                                </Row>
                                                <Row>
                                                    {showIndividualList &&
                                                        <Col className="col-md-9  col-12">
                                                            <Form.Group>
                                                                <Form.Label>Individual Profile
                                                                    {
                                                                        scrMode === "A" &&
                                                                        <span>  <span className='tranNewFormText'
                                                                            onClick={() => newIndividual()}
                                                                        >Not in list? Create New </span>
                                                                            <span>
                                                                                <Badge bg="secondary" onClick={handleReset}>Reset</Badge>
                                                                            </span>
                                                                        </span>

                                                                    }
                                                                </Form.Label>
                                                                <AsyncSelect
                                                                    cacheOptions={false}
                                                                    defaultOptions={false}
                                                                    value={nIndividual}
                                                                    getOptionLabel={e => e.label + ' '}
                                                                    getOptionValue={e => e.id}
                                                                    loadOptions={Picklist.fetchIndividualMainPicklist}
                                                                    onInputChange={Picklist.handleInputChange}
                                                                    onChange={handleNewIndiviualChange}
                                                                    isDisabled={scrMode === "Q"}
                                                                    formatOptionLabel={Picklist.formatOptionLabel}
                                                                    components={{ Menu: Picklist.menu }}
                                                                >
                                                                </AsyncSelect>
                                                            </Form.Group>
                                                        </Col>
                                                    }
                                                </Row>&nbsp;
                                                <Row>
                                                    <Col className="col-md-3 col-6">
                                                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleAdd} >Add</Button>&nbsp;
                                                        <Form.Check
                                                            type="checkbox"
                                                            label="Show Additional Details"
                                                            checked={isChecked}
                                                            onChange={handleCheckboxChange}
                                                        />
                                                    </Col>
                                                </Row>
                                            </> : null
                                        }
                                        <Row>&nbsp;</Row>
                                        {showList &&
                                            <>
                                                <Row>
                                                    <Col>
                                                        <Table striped bordered hover>
                                                            <thead>
                                                                {
                                                                    totalDifference != '0' &&
                                                                    <>
                                                                        <tr>
                                                                            {
                                                                                isChecked ?
                                                                                    <td
                                                                                        colSpan={10}
                                                                                    ></td> : <td
                                                                                        colSpan={7}
                                                                                    ></td>
                                                                            }
                                                                            {
                                                                                totalDifference != 0 &&
                                                                                <td style={{ textAlign: 'right' }} colSpan={1}><b>Total Difference:</b> <span>{totalDifference}</span></td>
                                                                            }

                                                                        </tr>
                                                                    </>
                                                                }
                                                                <tr>
                                                                    {
                                                                        isChecked ?
                                                                            <td
                                                                                colSpan={9}
                                                                            ></td> : <td
                                                                                colSpan={6}
                                                                            ></td>
                                                                    }
                                                                    {/* <td
                                                                                    colSpan={8}
                                                                                ></td> */}
                                                                    <td style={{ textAlign: 'right' }} colSpan={1}><b>Total Debit:</b> <span>{Math.abs(totalDebit)}</span></td>
                                                                    <td style={{ textAlign: 'right' }} colSpan={1}><b>Total Credit:</b> <span>{Math.abs(totalCredit)}</span></td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Action</th>
                                                                    {/* <th>Sr No</th> */}
                                                                    <th>Group</th>
                                                                    <th>Account</th>
                                                                    {/* <th>Account Type</th> */}
                                                                    <th>Account Name</th>
                                                                    <th>Individual</th>
                                                                    <th>Knockoff</th>
                                                                    {/* <th>Narration</th> */}

                                                                    <th style={{ textAlign: 'right' }}>Debit</th>
                                                                    <th style={{ textAlign: 'right' }}>Credit</th>
                                                                    {isChecked && <>
                                                                        <th>Cheque Number</th>
                                                                        <th>Cheque Date</th>
                                                                        <th>Cheque Bank Name</th>
                                                                    </>}

                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    bookList.filter(res => res.tfd_reftype !== "GB").map((res, index) =>
                                                                        <>
                                                                            <tr key={index}>
                                                                                <td className="textCenter" >
                                                                                    {userRight.query === "1" && (scrMode == 'E' || scrMode == 'A') && res.delny == "Y" ?
                                                                                        <span className="handCursor colorThemeBlue"
                                                                                            onClick={() => handleDelete(res)}>
                                                                                            <FontAwesomeIcon icon={faTrash} />
                                                                                        </span>
                                                                                        : null
                                                                                    }
                                                                                </td>
                                                                                {/* <td>{res.tfd_line_no}</td> */}
                                                                                <td>{res.tfd_group}</td>
                                                                                <td>{res.tfd_account}</td>
                                                                                <td>{res.mvli_ledger_name}</td>
                                                                                <td>{res.tfd_individual}</td>
                                                                                <td>{res.tfd_knockoff_srno == 0 ? '' : res.tfd_knockoff_srno + ' ' + res.tfd_knockoff_type}</td>
                                                                                {/* <td>{<span className='colorThemeBlue' onClick={() => copyNarrationValue(res.tfd_location, res.tfd_type || res.tfd_knockoff_type, res.tfd_srno || res.tfd_knockoff_srno, res.tfd_line_no || res.tfd_knockoff_lineno)}>
                                                                                    <FontAwesomeIcon icon={faCopy} />
                                                                                </span>}</td> */}
                                                                                <td style={{ textAlign: 'right' }}>{res.tfd_flag == 'D' && Math.abs(res.tfd_amount).toFixed(2)}</td>
                                                                                <td style={{ textAlign: 'right' }}>{res.tfd_flag == 'C' && Math.abs(res.tfd_amount).toFixed(2)}</td>
                                                                                {isChecked && <>
                                                                                    <td>{res.tfd_cheque_no}</td>
                                                                                    <td>{res.cheque_date}</td>
                                                                                    <td>{res.tfd_cheque_bank_name}</td>
                                                                                </>}

                                                                            </tr>
                                                                            {
                                                                                res.tfd_cheque_no !== "" &&
                                                                                <tr>
                                                                                    <td colSpan={12}>Ref/Cheque Num : {res.tfd_cheque_no}</td>
                                                                                </tr>
                                                                            }
                                                                        </>
                                                                    )
                                                                }
                                                            </tbody>
                                                            <br /><br />
                                                            <tbody>
                                                                {
                                                                    bookList.filter(res => res.tfd_reftype === "GB").map((res) =>
                                                                        <tr key={res.tfd_line_no}>
                                                                            <td className="textCenter" >{res.tfd_reftype}</td>
                                                                            {/* <td>{res.tfd_line_no}</td> */}
                                                                            <td>{res.tfd_group}</td>
                                                                            <td>{res.tfd_account}</td>
                                                                            <td>{res.mvli_ledger_name}</td>
                                                                            <td>{res.tfd_individual}</td>
                                                                            <td>{res.tfd_knockoff_srno == "null" || res.tfd_knockoff_srno == null ? '' : res.tfd_knockoff_srno + ' ' + res.tfd_knockoff_type}</td>
                                                                            <td style={{ textAlign: 'right' }}>{res.tfd_flag == 'D' && Math.abs(res.tfd_amount)}</td>
                                                                            <td style={{ textAlign: 'right' }}>{res.tfd_flag == 'C' && Math.abs(res.tfd_amount)}
                                                                            </td>
                                                                            {isChecked && <>
                                                                                <td>{res.tfd_cheque_no}</td>
                                                                                <td>{res.cheque_date}</td>
                                                                                <td>{res.tfd_cheque_bank_name}</td>
                                                                            </>}

                                                                        </tr>
                                                                    )
                                                                }
                                                            </tbody>
                                                        </Table>
                                                    </Col>
                                                </Row>
                                                <Col className="text-end">
                                                    Number of rows : {bookList?.length || 0}
                                                </Col>
                                            </>
                                        }
                                        <Row>&nbsp;</Row>
                                        {scrMode != '' ?
                                            <FloatingLabel controlId="floatingTextarea2" label="Narration">
                                                <Form.Control
                                                    value={narration}
                                                    maxLength={999}
                                                    as="textarea"
                                                    placeholder="Leave a comment here"
                                                    style={{ height: '100px' }}
                                                    onChange={(e) => setNarration(e.target.value)}
                                                    disabled={scrMode == 'Q'}
                                                />
                                            </FloatingLabel>
                                            : null
                                        }
                                        <Row><Col>&nbsp;</Col></Row>
                                        <Row>
                                            <Col >
                                                {scrMode == 'A' || scrMode == 'E' ?
                                                    <Button variant='outline-danger' className='buttonStyle' size='sm' onClick={handleCancel} >Cancel</Button>
                                                    : <Button variant='outline-danger' className='buttonStyle' size='sm' onClick={handleBack}>Back</Button>
                                                }&nbsp;
                                                {
                                                    (userRight.edit === "1" && scrMode === 'Q') ?
                                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                            btnEditRequest()}>Edit</Button>
                                                        : null
                                                }
                                                {
                                                    (userRight.query === "1" && scrMode === 'Q') ? <>
                                                        <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() =>
                                                            handleDownload("P")}>Print</Button> &nbsp;
                                                        {
                                                            sessionStorage.getItem('userSrno') == "1" &&
                                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                                handleDownload("A")}>Advance
                                                            </Button>
                                                        }
                                                    </> : null
                                                } &nbsp;
                                                {
                                                    (userRight.query === "1" && (scrMode === 'E' || scrMode === 'Q')) ? <>
                                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                            btnActivityLog()}>Activity Log</Button>
                                                    </> : null
                                                }
                                                {
                                                    (userRight.query === "1" && scrMode === 'Q') &&
                                                    <Button variant='outline-success' className='buttonStyle' size='sm'
                                                        onClick={handleAddNew}>Add New
                                                    </Button>
                                                }
                                                &nbsp;
                                                {
                                                    (userRight.edit === "1" && scrMode === 'E') || (userRight.add === "1" && scrMode === 'A') ?
                                                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleSave} >Save</Button> : null
                                                }


                                            </Col>
                                        </Row>&nbsp;
                                    </>
                            }
                            <Row>&nbsp;</Row>
                            <Row>&nbsp;</Row>
                            <Row>&nbsp;</Row>
                        </Container>
                    </>
            }
            {/* </>
            } */}


            <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />

            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                {msgTextYN}
            </DialogYesNo>
            <CancelDialog isOpen={msgBoxYNBillDelete} onYes={handleDeleteBill} onNo={(e) => setMsgBoxYNBillDelete(false)}>
                {msgTextYNBillDelete}
            </CancelDialog>
            <Tran_data_unlock_request logObject={editLogObject} show={showEditRequest} onHide={() => setShowEditRequest(false)} />

            <div>
                <Modal size='lg' show={showModal} onHide={() => setShowModal(false)} animation={false} centered>
                    <Modal.Body>
                        {
                            scrMode === 'E' ?
                                <>
                                    <Form.Group>
                                        <Form.Label>Reason<span className="text-danger">*</span></Form.Label>
                                        <Form.Control type="text" placeholder="Reason" maxLength={499}
                                            value={acRemark}
                                            onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setAcRemark)}
                                            autoComplete="off"
                                            required />
                                    </Form.Group>
                                </> :
                                null
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-success" onClick={() => btnSaveModal()}>
                            Save
                        </Button>{' '}
                        <Button variant="outline-success" onClick={() => setShowModal(false)}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </>
    )
}

export default Tran_fa_book;
